
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/lead-targeting",
      function () {
        return require("private-next-pages/use-cases/lead-targeting.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/lead-targeting"])
      });
    }
  